











import { Component, Vue } from 'vue-property-decorator';
import Warning from './Warning.vue';
import { Dictionary } from 'vue-router/types/router';
import { authUser } from '@/auth/User.ts';
import EventBus from '../event-bus';

@Component({
    components: {
        'warning': Warning
    }
})
export default class WarningStream extends Vue
{    
    loading: boolean = false;
    notifications: boolean = false;
    messageList: Array<any> = [];
    beforeMount() {
        this.$http.get('/emma/admin/warnings' )
            .then( resp => { 
                this.messageList = resp.data;
                this.messageList.forEach( el => el.is_sent = el.user_id == authUser.id );
            });
        EventBus.$on( 'remove-warning', (warning: any) => {
            const index = this.messageList.indexOf(warning);
            if( index > -1 )
                this.messageList.splice( index, 1 );
        });

        EventBus.$on('new-warning', (warning: any) => {
            this.messageList.unshift(warning);
            this.notifications = true;
        });
    }

    async loadMoreWarnings () 
    {
        let resp = null;
        try
        {
            this.loading = true;
            const last_message = this.messageList[ this.messageList.length - 1 ];
            const last_id = last_message[ 'id' ];
            resp = await this.$http.get('/emma/admin/warnings', { params: { after: last_id } } );
            resp.data.forEach( (el: any) => el.is_sent = el.user_id == authUser.id );
            this.messageList.push( ...resp.data );
        }
        catch( e )
        {

        }
        finally
        {
            if( resp && resp.data.length == 0 )
              this.loading = true;
            else
              this.loading = false;
        }

    }
}
